import React from "react";
import { Link } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";

const AnalyticsNavigation = ({ activeTab }) => {
  return (
    <div className="mb-4">
      <Nav tabs className="nav-tabs-custom">
        <NavItem>
          <NavLink
            tag={Link}
            to="/analytics/dashboard"
            className={activeTab === "dashboard" ? "active" : ""}
          >
            <i className="mdi mdi-chart-bar me-1"></i> Dashboard
          </NavLink>
        </NavItem>
        {/* <NavItem>
          <NavLink
            tag={Link}
            to="/analytics/users"
            className={activeTab === 'users' ? 'active' : ''}
          >
            <i className="mdi mdi-account-group me-1"></i> Users
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to="/analytics/trading"
            className={activeTab === 'trading' ? 'active' : ''}
          >
            <i className="mdi mdi-chart-line me-1"></i> Trading
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to="/analytics/markets"
            className={activeTab === 'markets' ? 'active' : ''}
          >
            <i className="mdi mdi-calendar-check me-1"></i> Events & Markets
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to="/analytics/categories"
            className={activeTab === 'categories' ? 'active' : ''}
          >
            <i className="mdi mdi-shape me-1"></i> Categories
          </NavLink>
        </NavItem> */}
      </Nav>
    </div>
  );
};

export default AnalyticsNavigation;
